<template>
  <div class="row">
    <LoaderMaskComponent v-if="lyLoading" />
      <div v-else class="col_12">
        <h1 class="common_title">Roles</h1>
        <div class="card">
          <div class="card_heading">
            <div class="add_item_cat link m15 ">
              <span v-if="!showForm" class="add_new_cat_open pointer" @click.prevent="addNewCategory">+ Add a New Role</span>
              <span class="ml_10">Click Role From List To Edit.</span>
            </div>
          </div>
          <div class="card_body">
            <div class="item_short_wrap">
              <nested-draggable
                  v-if="categories.length > 0"
                  :categories="categories"
                  :child="child"
                  @update-prop-value="updatePropValue"
                  @editCategory="editCategory"
              />

              <div v-show="showForm" class="add_new_cat pl_15">
                <div class="add_new_inner">
                  <div class="float_right">
                    <span class="close_icon item_cat_close" @click.prevent="closeAddEdit"></span>
                  </div>
                  <h4 class="item_cat_heading mb_20">{{ newForm ? 'Add New' : 'Edit' }} Role</h4>
                  <div class="add_new_cat_form">
                    <div :class="['form_row_inline', {'has_error': errorFor('name')}]">
                      <label class="">Role Name</label>
                      <div class="form_input">
                        <input type="text" class="form_global" name="name" v-model="form.name">
                      </div>
                      <v-errors :errors="errorFor('name')"></v-errors>
                    </div>
                    <div :class="['form_row_inline', {'has_error': errorFor('parent')}]">
                      <label class="">Permissions</label>
                      <div class="form_input">
                        <Multiselect
                            v-model="form.permissions"
                            :options="permissions"
                            :multiple="true"
                            :close-on-select="true"
                            placeholder="Select permission"
                            label="name"
                            track-by="id"
                            :optionHeight="20"
                        />
                      </div>
                      <v-errors :errors="errorFor('parent')"></v-errors>
                    </div>
                    <div class="text_right m15">
                      <div class="display_inline mr_0">
                        <button class="btn btn_danger mr_10 min_width_100p" v-if="!newForm && category"
                                @click.prevent="deleteRecord(category)">Delete
                        </button>
                        <button class="btn btn_primary min_width_100p" @click.prevent="submit">Save</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import nestedDraggable from "./NestedRole.vue";
import LoaderMaskComponent from "@/components/LoaderMaskComponent.vue";
import Multiselect from "vue-multiselect";

export default {
  name: 'categories',
  components: {Multiselect, LoaderMaskComponent, nestedDraggable},
  data() {
    return {
      lyLoading: false,
      showForm: false,
      newForm: true,
      firstLoad: false,
      form: {
        name: '',
        permissions: '',
      },
      categoryList: [],
      categories: [],
      subCategories: [],
      category: null,
      child: false,
      permissions: [],
      selectedPermission: null,
    }
  },
  watch: {},
  mounted() {
    this.loadData();
    this.loadPermissions();
  },
  methods: {
    closeAddEdit(){
      this.showForm = false
      this.allErrors = null;
    },
    updatePropValue() {
      this.child = !this.child;
    },
    addNewCategory() {
      this.resetForm();
      this.newForm = true;
      this.showForm = true
    },
    resetForm() {
      this.form = {
        name: '',
        permission: '',
      }
    },
    editCategory(category) {
      this.resetForm();
      this.categoryList = this.categories
      this.axios.get(`/roles/${category.id}`)
          .then((response) => {
            let data = response.data.data

            if (data.parent && data.permissions) {
              category.permissions = data.permissions
            } else {
              category.permissions = data.permissions
            }
          })
      this.categoryList = window._.filter(this.categoryList, (c) => c.id !== category.id)
      this.category = category
      this.form = category
      this.newForm = false;
      this.showForm = true;
    },
    loadData() {
      this.lyLoading = true;
      this.axios.get('/roles').then((response) => {
        this.categories = response.data.data
        this.categoryList = response.data.data
      }).finally(() => {
        this.lyLoading = false;
      })
    },
    loadPermissions() {
      this.axios.get('/get-permissions').then(({ data }) => {
        this.permissions = data.data
      }).finally(() => {
        this.lyLoading = false;
      })
    },
    submit() {
      this.errors = null;
      this.lyLoading = true;

      let permissions = this.form.permissions?.map((item) => item.id)

      let formData = new FormData()

      Object.keys(this.form).forEach(key => {
        const value = this.form[key] === 0 ? 0 : (this.form[key] ? this.form[key] : '');
        formData.append(key, value);
      });
      formData.delete('permissions')
      formData.append('permissions', permissions)

      if (this.newForm) {
        this.axios.post('/roles', formData)
            .then(() => {
              this.showForm = false;
              this.showSuccessMsg('Successfully Saved!')
              this.loadData();
              this.resetForm()
            })
            .catch((err) => {
              this.allErrors = err.response.data.errors
            })
            .finally(() => {
              this.lyLoading = false;
            })
      } else {
        formData.append('_method', 'PATCH')

        this.axios.post('/roles/' + this.form.id, formData)
            .then(() => {
              this.showForm = false;
              this.showSuccessMsg('Successfully Saved!')
              this.loadData();
              this.resetForm()
            })
            .catch((err) => {
              this.allErrors = err.response.data.errors
            })
            .finally(() => {
              this.lyLoading = false;
            })
      }
    },
    deleteRecord(category) {
      this.$swal({
        title: 'Are you sure want to delete?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        confirmButtonColor: '#dd4b39',
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          this.axios.delete('/roles/' + category.id).then(() => {
            this.category = null
            this.showForm = false
            this.allErrors = null;
            this.$swal.fire(
                'Deleted',
                'Role has been deleted!',
                'success'
            )
            this.loadData();
          });
        }
      });
    },
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.css"></style>
<style scoped lang="scss">
.opacity_remove {
  opacity: 0;
}

.d_block {
  display: block;
}
</style>